import * as React from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';

import { NavigationTabs } from "../../components/tab/NavigationTabs";
import { GamesListTab } from "./GamesListTab";
import { GameFiltersTab } from "./GameFiltersTab";
import { GameInventoryTab } from "./GameInventoryTab";

export function GamesTabsPage() {
    return (
        <Box sx={{display: 'flex', minHeight: '100dvh'}}>
            <Box
                component="main"
                className="MainContent"
                sx={{
                    px: {xs: 2, md: 6},
                    pt: {
                        xs: 'calc(12px + var(--Header-height))',
                        sm: 'calc(12px + var(--Header-height))',
                        md: 3,
                    },
                    pb: {xs: 2, sm: 2, md: 3},
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                    height: '100dvh',
                    gap: 1,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        mb: 1,
                        gap: 1,
                        flexDirection: {xs: 'column', sm: 'row'},
                        alignItems: {xs: 'start', sm: 'center'},
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography level="h2" component="h1">
                        Игры
                    </Typography>
                </Box>
                <NavigationTabs
                    tabs={[
                        {
                            tabSlug: 'games',
                            tabTitle: 'Игры',
                            tabContent: <GamesListTab/>,
                        },
                        {
                            tabSlug: 'filters',
                            tabTitle: 'Фильтры',
                            tabContent: <GameFiltersTab/>,
                        },
                        {
                            tabSlug: 'inventory',
                            tabTitle: 'Инвентари',
                            tabContent: <GameInventoryTab/>,
                        },
                    ]}
                />
            </Box>
        </Box>
    );
}

